import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ServiceAccountIcon = props => (
  <Icon viewBox="0 0 48 48" w="full" h="full" color="inherit" {...props}>
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width="48" height="48" fill="none" />
      </g>
      <g id="Layer_7" data-name="Layer 7">
        <g>
          <path d="M25.1,41H4a2,2,0,0,1-2-2V31.1l1-.6A25.6,25.6,0,0,1,16,27a26.7,26.7,0,0,1,7.5,1.1,21.2,21.2,0,0,0-.5,4.4A18.4,18.4,0,0,0,25.1,41Z" fill="currentColor" />
          <path d="M16,23a9,9,0,1,0-9-9A9,9,0,0,0,16,23Z" fill="currentColor" />
          <path d="M46,34.1V31.9L42.4,31l-.5-1.1,2-3.2-1.6-1.6-3.2,2L38,26.6,37.1,23H34.9L34,26.6l-1.1.5-3.2-2-1.6,1.6,2,3.2L29.6,31l-3.6.9v2.2l3.6.9.5,1.1-2,3.2,1.6,1.6,3.2-2,1.1.5.9,3.6h2.2l.9-3.6,1.1-.5,3.2,2,1.6-1.6-2-3.2.5-1.1ZM36,36a3,3,0,1,1,3-3A2.9,2.9,0,0,1,36,36Z" fill="currentColor" />
        </g>
      </g>
    </g>
  </Icon>
);
